/**
 *
 * ModalDeleteSimple
 *
 */

import React from "react"
import { Modal, Button } from "antd"
import alertSvg from "../../images/alert.svg"
import "./index.less"
import { ConfirmIcon } from "../../icons/svg/iconConfirm"
import { loadTexts } from "../../utils/i18n"

/* eslint-disable react/prefer-stateless-function */
class ModalDeleteSimple extends React.Component {
  intl = loadTexts("dashboard")
  render() {
    return (
      <Modal
        className="modalCustom"
        visible={this.props.visible}
        style={{ top: 76 }}
        onCancel={this.props.onCancel}
        footer={[
          <Button key="back" onClick={this.props.onCancel}>
            {this.intl.actionPlanCard.deleteModal.cancel}
          </Button>,
          <Button
            className="component-deletesimple__button-delete"
            key="submit"
            type="danger"
            onClick={this.props.onOk}
            loading={this.props.loading || false}>
            {this.intl.actionPlanCard.deleteModal.delete}
          </Button>,
        ]}
        width={520}>
        <div className="component-deletesimple">
          <ConfirmIcon />
          {/* <div className='component-deletesimple__description'>
            <p>
              <span>¿Estás seguro de que deseas eliminar el cuestionario?</span>
            </p>
          </div> */}
          <div className="component-deletesimple__description">
            {this.props.content}
          </div>
        </div>
      </Modal>
    )
  }
}

export default ModalDeleteSimple
